import { Box, Button, Switch, Tooltip, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import React, { useEffect, useState } from "react";
import style from "../RegListActionCard.module.css";
import FormInputMSPerson from "../../../Inputs/FormInputMSPerson";
import FormInputSwitch from "../../../Inputs/FormInputSwitch";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

import GroupAddIcon from "@mui/icons-material/GroupAdd";
import FormInputText from "../../../Inputs/FormInputText";

const RegisterGroup = ({ show, workshopIsFull, registerGroup }) => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: { attendees: "", sendMail: true, addEvent: false },
    criteriaMode: "all",
    mode: "onChange",
  });

  const onSubmit = (data) => {
    registerGroup(data.attendees, data.sendMail, data.addEvent);
    reset();
  };

  const onError = (data) => {
    console.log("error ", data);
  };

  return (
    <Box className={`${style.container} ${!show && style.hidden}`}>
      <form>
        <Typography variant="h5">Register a group of users</Typography>
        <Typography variant="body1">
          Enter email addresses separated by commas
        </Typography>
        <Typography
          variant="body2"
          sx={{ fontStyle: "italic", marginBottom: "0.5rem" }}
        >
          example: test@surreyschools.ca, abc@surreyschools.ca
        </Typography>
        <Typography variant="body1" sx={{ marginBottom: "0.5rem" }}>
          Registrations will be added in the order entered. If there are more
          than available seats the overflow will be put on the waitlist
        </Typography>
        <FormInputText
          name="attendees"
          label="Email Addresses"
          control={control}
          rules={{
            required: {
              value: true,
              message: "Please enter at least one email address",
            },
            //regex to ensure comma separated emails
            pattern: {
              value:
                /^([a-zA-Z][a-zA-Z0-9_.]+@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}(, )*)+$/,
              message: "Enter valid email addresses separated by commas",
            },
          }}
          error={errors.attendees?.message}
        />
        <Box className={style.section}>
          <Typography variant="body1">
            Add information to all user's Outlook
          </Typography>
          <Box sx={{ display: "flex" }}>
            <Box>
              <FormInputSwitch
                name="sendMail"
                label="Send email"
                control={control}
              />
            </Box>

            {!workshopIsFull && (
              <Box>
                <FormInputSwitch
                  name="addEvent"
                  label="Add to calendar"
                  control={control}
                />
              </Box>
            )}
          </Box>
        </Box>

        <Button
          variant="contained"
          onClick={(e) =>
            handleSubmit(
              onSubmit,
              onError
            )(e).catch((e) => {
              console.log("e", e);
            })
          }
          startIcon={workshopIsFull ? <AccessTimeIcon /> : <GroupAddIcon />}
        >
          {workshopIsFull ? "Add to waitlist" : "Register users"}
        </Button>
      </form>
    </Box>
  );
};

export default RegisterGroup;
